export const ACTIVE = 'Active';
export const COMPLETE = 'Complete';
export const EXCLUDE = 'Exclude';
export const NEW = 'New';
export const APP = 'CM ICOC Report Contract Picker';

export type TStatus = 'Active' | 'Complete' | 'Exclude' | 'New' | 'Admin';